import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import css from './indicator.css';

const Indicator = ({ inverse }) => (
  <svg
    width='32'
    height='32'
    className={classnames(css['ds-indicator'])}
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      className={classnames(css['ds-indicator__circle'], {
        [css['ds-indicator__circle--inverse']]: inverse,
      })}
      fill='transparent'
      cx='16'
      cy='16'
      r='14'
    />
  </svg>
);

Indicator.defaultProps = {
  inverse: false,
};

Indicator.propTypes = {
  inverse: PropTypes.bool,
};

export default Indicator;
